<template>
  <div>
    <div>
      <!-- <div>
        <search></search>
      </div> -->
      <div>
<img src="/xibc2.png" width="100%" />
      </div>
      <div>
<img src="/xibc3.png" width="60%" />
      </div>
      <!-- <div style="text-align: left;">
      &nbsp;&nbsp;&nbsp;&nbsp;厦门外图集团有限公司前身为厦门对外图书交流中心，1989年由中国外文出版发行事业局和厦门市人民政府共同投资设立，2009年转企改制为国有文化企业集团。集团现拥有12个直属部门，8个子公司和1个出版媒体，近2万平方米书城书店经营场所和1.2万平方米的物流中心，在职员工385人，年经营规模超11亿元人民币，一般商品进出口贸易超1亿美元,对台图书进出口贸易长期保持全国第一，已成为对台图书文化交流优质平台。
      </div>
      <div style="text-align: left;">
      &nbsp;&nbsp;&nbsp;&nbsp;集团先后执行了12个国家重点文化项目，连续六届被中宣部、国家商务部、国家财政部、国家文化部、国家新闻出版署联合评定为“国家文化出口重点企业”，获评全国新闻出版“走出去”先进单位、全国文化体制改革工作先进单位、全国守合同重信用企业、福建省文化企业十强、福建省新闻出版系统先进集体、福建省文化出口重点培育企业、厦门市重点文化企业、厦门市文明单位等荣誉称号。
      </div>
      <div style="text-align: left;">
      &nbsp;&nbsp;&nbsp;&nbsp;三十年来，厦门外图集团有限公司用心服务每一位读者和客户，从厦门到台北，从海峡两岸到全球各地。新时代，厦门外图集团有限公司将继续秉承“利国利民利己，共存共生共兴”的经营宗旨，在整合资源，加快实现集团公司转型发展与创新突破的同时，积极承担文化企业社会责任，为倡导全民阅读、构建书香社会、推动中华文化“走出去”，为实现中华民族伟大复兴的中国梦贡献力量！
      </div> -->
    </div>
  </div>
</template>

<script>
import search from "@/components/search.vue";

export default {
  components: {
    search
  }
};
</script>
